import { Checkbox, CheckboxProps, FormControl, FormControlLabel } from "@mui/material";
import { MprcText } from "components/MprcText";
import * as React from "react";

interface IProps {
    labelColor?: MprcColors | [MprcColors, MprcColorVariant] | "inherit";
    label: React.ReactNode;
    margin?: MuiMargin;
}

type Props = IProps & Omit<CheckboxProps, "color">;

export const MprcCheckBox: React.FC<Props> = (props) => {
    const { margin, label, labelColor = ["muted", "dark"], ...checkboxProps } = props;

    return (
        <FormControl margin={margin}>
            <FormControlLabel
                control={
                    <Checkbox {...checkboxProps} />
                }
                label={<MprcText color={labelColor}>{label}</MprcText>}
            />
        </FormControl>
    );
};
